export default {
    render(){},
    mounted() {
        window.dataLayer = window.dataLayer || []
        dataLayer.push(this.object);
    },
    computed: {
        object() {
            let object = {
                'event': 'page_view',
				'items':[{
					'google_business_vertical': 'retail'
				}]
            };
            return object;
        }
    }
}
